/**
 * Filters
 * Tout ce qui filtre ou trie des listes.
 */

import { timeToMinutes } from "./formatters.js";

// ─── Activity ───────────────────────────────────────────────────

export const FILTER_STATUS = {
  ALL: "all",
  ACTIVE: "active",
  INACTIVE: "inactive",
};

/**
 * Check if an item is currently active based on start and end dates
 */
export function isActive(startDate, endDate) {
  const now = new Date();
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;

  if (start && start > now) return false;
  if (end && end < now) return false;
  return true;
}

// ─── Users ──────────────────────────────────────────────────────

/**
 * Filter users by activityStatus, userType, searchTerm
 */
export function filterUsers(users, filters = {}) {
  if (!Array.isArray(users)) return [];

  let filtered = [...users];

  if (filters.activityStatus && filters.activityStatus !== FILTER_STATUS.ALL) {
    const wantActive = filters.activityStatus === FILTER_STATUS.ACTIVE;
    filtered = filtered.filter(
      (u) =>
        isActive(u.activity_start_date, u.activity_end_date) === wantActive,
    );
  }

  if (filters.userType && filters.userType !== FILTER_STATUS.ALL) {
    filtered = filtered.filter((u) => u.user_type === filters.userType);
  }

  if (filters.searchTerm?.trim()) {
    const term = filters.searchTerm.toLowerCase().trim();
    filtered = filtered.filter((u) => {
      const first = (u.first_name || "").toLowerCase();
      const last = (u.last_name || "").toLowerCase();
      const email = (u.email || "").toLowerCase();
      return (
        first.includes(term) ||
        last.includes(term) ||
        `${first} ${last}`.includes(term) ||
        email.includes(term)
      );
    });
  }

  return filtered;
}

/** Sort users by last_name + first_name */
export function sortUsersByName(users, order = "asc") {
  if (!Array.isArray(users)) return [];

  return [...users].sort((a, b) => {
    const nameA = `${a.first_name || ""} ${a.last_name || ""}`.toLowerCase();
    const nameB = `${b.first_name || ""} ${b.last_name || ""}`.toLowerCase();
    return order === "desc"
      ? nameB.localeCompare(nameA)
      : nameA.localeCompare(nameB);
  });
}

// ─── Slots ──────────────────────────────────────────────────────

/**
 * Filter slots that have valid times and fall within [startHour, endHour]
 */
export function getValidSlots(slots, startHour, endHour) {
  if (!Array.isArray(slots)) return [];

  return slots.filter((slot) => {
    if (slot.start_time == null || slot.end_time == null) return false;

    const startMin =
      typeof slot.start_time === "number"
        ? slot.start_time
        : timeToMinutes(slot.start_time);
    const endMin =
      typeof slot.end_time === "number"
        ? slot.end_time
        : timeToMinutes(slot.end_time);

    if (startMin >= endMin) return false;
    if (startMin / 60 >= endHour || endMin / 60 <= startHour) return false;

    return true;
  });
}
